import React from "react"
import { ReactChildren } from "ui/types"

type Props = {
    label: string,
    children: ReactChildren,
}

export const MenuTitle = ({
    label,
    children,
}: Props) => {

    return (
        <div className="menu-title-wrapper">
            <div className="menu-title-label">{label}</div>
            <div className="menu-title-content">
                {children}
            </div>
        </div>
    )
}